var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 664.572,
    height: 434.948,
    viewBox: "0 0 664.572 434.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sell_more_deals_and_earn_higher_commissions",
    "data-name": "Sell more deals and earn higher commissions",
    transform: "translate(-5.603 -0.451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 557.497,
    height: 406.727,
    rx: 20,
    transform: "translate(55.186 28.672)",
    fill: "#44577a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M55.186,20.451a20,20,0,0,1,20-20h517.5a20,20,0,0,1,20,20V71.622H55.186Z",
    fill: "#11c1ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 5.519,
    cy: 5.519,
    r: 5.519,
    transform: "translate(83.5 30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 5.519,
    cy: 5.519,
    r: 5.519,
    transform: "translate(102.756 30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 5.519,
    cy: 5.519,
    r: 5.519,
    transform: "translate(123.851 30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 149.274,
    height: 238.223,
    rx: 20,
    transform: "translate(5.603 127.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 231.468,
    height: 238.223,
    rx: 20,
    transform: "translate(182.012 127.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 98.164,
    height: 10.767,
    rx: 5.383,
    transform: "translate(32.43 280.654)",
    fill: "#001337",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 80.728,
    height: 10.767,
    rx: 5.383,
    transform: "translate(32.43 301.78)",
    fill: "#001337",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 45.094,
    height: 10.767,
    rx: 5.383,
    transform: "translate(32.43 321.384)",
    fill: "#001337",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 185.335,
    height: 169.276,
    rx: 26,
    transform: "translate(205.078 160.193)",
    fill: "#11c1ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 185.335,
    height: 169.276,
    rx: 26,
    transform: "translate(205.078 160.193)",
    fill: "#11c1ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 3.693,
    height: 140.734,
    rx: 1.847,
    transform: "translate(238.943 175.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 3.693,
    height: 140.734,
    rx: 1.847,
    transform: "translate(261.726 175.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 3.693,
    height: 140.734,
    rx: 1.847,
    transform: "translate(284.508 175.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 3.693,
    height: 140.734,
    rx: 1.847,
    transform: "translate(307.29 175.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 3.693,
    height: 140.734,
    rx: 1.847,
    transform: "translate(330.072 175.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 3.693,
    height: 140.734,
    rx: 1.847,
    transform: "translate(352.854 175.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M230.3,291.75c13.91-.409,39.935-11.649,56.459-42.959,23.32-44.186,54.823-43.367,74.87-44.186",
    fill: "none",
    stroke: "#11c1ff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M233.017,296.347c13.91-.409,39.935-11.649,56.459-42.959C312.8,209.2,344.3,210.021,364.346,209.2",
    fill: "none",
    stroke: "#11c1ff",
    strokeWidth: 3,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 5.286,
    cy: 5.286,
    r: 5.286,
    transform: "translate(355.493 198.991)",
    fill: "#11c1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 231.468,
    height: 238.223,
    rx: 20,
    transform: "translate(438.706 127.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 35.18,
    height: 169.276,
    rx: 10,
    transform: "translate(464.87 161.098)",
    fill: "#11c1ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 35.18,
    height: 70.921,
    rx: 10,
    transform: "translate(464.87 259.454)",
    fill: "#9be3fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 35.18,
    height: 169.276,
    rx: 10,
    transform: "translate(513.226 161.098)",
    fill: "#11c1ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 35.18,
    height: 109.418,
    rx: 10,
    transform: "translate(513.226 220.957)",
    fill: "#9be3fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 35.18,
    height: 169.276,
    rx: 10,
    transform: "translate(609.938 161.098)",
    fill: "#11c1ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 35.18,
    height: 155.005,
    rx: 10,
    transform: "translate(609.938 175.37)",
    fill: "#9be3fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 35.18,
    height: 169.276,
    rx: 10,
    transform: "translate(561.582 161.098)",
    fill: "#11c1ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 35.18,
    height: 129.65,
    rx: 10,
    transform: "translate(561.582 200.724)",
    fill: "#9be3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M95.312,144.974A58.232,58.232,0,1,0,137.8,192.433L80.24,201.222Z",
    fill: "#11c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M138.472,201.222a58.232,58.232,0,1,0-83.867,52.286L80.24,201.222Z",
    fill: "#11c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M109.355,150.792a58.231,58.231,0,1,0,3.349,98.773L80.24,201.222Z",
    fill: "#11c1ff",
    opacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.270216bc5e9032d767e3afe70121fd0b.svg";
export { ForwardRef as ReactComponent };